import BaseApiService from './base';

export class BackgroundImageApiService extends BaseApiService {
    // eslint-disable-next-line
    constructor() {
      super();
    }

    get() {
      return this.request({
        method: 'get',
        url: '/background-image',
      });
    }
}